import React, { useEffect, useRef, useState } from "react";
import CustomButtonLink from "../buttonComponent";
import { useLocation } from "react-router-dom";
import parse from "html-react-parser"

const Section1 = ({ data }) => {
    const location = useLocation();
     const firstPath = location.pathname.split("/")[1];
     const secondPath = location.pathname.split("/")[2];

  return (<>
    <div className={` w-full py-16 md:py-[105px] flex justify-center bg-cover  bg-bottom  bg-center bg-no-repeat  lg:bg-cover ${firstPath=="digital" || secondPath=="career"?"bg-digitalmobile bg-cover md:bg-digitalbg ":"bg-contentmobile md:bg-contentbg"}`}>
      <div className="2xl:container mx-auto w-full md:px-20 px-6  flex flex-col items-center relative">
        <div className={`flex lg:flex-row flex-col w-full gap-20  ${firstPath=="digital" || secondPath=="career"?"items-center justify-center":" justify-between "}`}>
          <div className={`lg:w-[60%] w-full gap-4 flex flex-col items-center text-center   ${firstPath=="digital" || secondPath=="career"?"lg:w-[90%]":"lg:text-left lg:items-start"} `} >
            <div className="flex gap-3 items-center">
              <img src={process.env.PUBLIC_URL +'/images/content/Star.svg'} alt="icon"/>
              <h4 className="text-16 md:text-18 text-orangeyellow font-medium">{data.contenttitle ? data.contenttitle.toUpperCase() : ""}</h4>
            </div>
            <h1 className={`text-32 text-primarycolor font-bold ${firstPath=="digital" || secondPath=="career"?" lg:text-64":"lg:text-48"} `}>{parse(data.heading)}</h1>
            <p className="text-14 sm:text-16 lg:text-18 text-secondaryblack">
              {parse(data.desc)}
            </p>
            <div className=" mt-6 md:mt-8 ">
            <CustomButtonLink to={secondPath=="career" ?"/company/career/apply":"/company/contactus"} label={secondPath=="career" ?"I’m Interested":"Get Started Now"}/>
            </div>
          </div>
       {firstPath=="digital" || secondPath=="career" ? <></>:(<div className="w-full flex justify-center lg:w-[40%]">
            <img className="h-full max-[450px]:w-[85%] w-[70%] sm:w-[80%] lg:w-full" src={process.env.PUBLIC_URL + data.headerImg} alt="img" />
          </div>)}
        </div>
      
       
      </div>
     
    </div>
    {data.industry && ( 
      <div className=" bg-Darkgray w-screen flex md:px-20 px-6">
      <div className="w-full flex flex-col lg:flex-row gap-2 lg:gap-10  items-center lg:justify-center">
         <p className="text-16 sm:text-16 md:text-18 text-white lg:text-primarycolor px-8 py-2 bg-transparent lg:bg-white my-2 font-semibold">INDUSTRY</p>
         <div className="flex items-center pb-4 lg:pb-0 flex-wrap gap-y-4 justify-center">
          {data.industry.map((item,i)=>(
            <p key={i} className={`text-white text-14 sm:text-16 px-3 lg:px-6 ${i==0?"pl-0 border-r-[1px] border-white":i==data.industry.length-1?"pr-0":"border-r-[1px] border-white"}`}>{item}</p>
          ))}
         </div>
         </div>
         </div>
         )}
         </>
  );
};

export default Section1;
